<article class="accent-switcher">
  <input #fileUpload type="file" (change)="onFileSelected($event)" accept="image/*" class="accent-switcher__hidden-input" aria-hidden="true" tabindex="-1">

  @if (customImage(); as img) {
    <div class="accent-switcher__container accent-switcher__custom-image-delete" (click)="removeCustomImage()" role="button" tabindex="0">
      <span class="material-symbols-rounded accent-switcher__file-icon accent-switcher__file-icon--close">close</span>
      <span class="accent-switcher__file-select-text">Clear image</span>
    </div>
  }
	@for (image of images(); track image; let i = $index) {
	    <div
	      class="accent-switcher__container"
	      [class.accent-switcher__container--selected]="activeIndex() === image"
	      (click)="image !== 'custom' && changeAccent(i, image)"
	      >
      @if (image === 'custom') {
        <div class="accent-switcher__custom-image">
          @if (customImage(); as img) {
            <div [attr.id]="'accent-' + image" class="accent-switcher__custom-image-container">
              <img [src]="img"
                class="accent-switcher__custom-image-img"
                alt="Custom image for material theming"
                (click)="setCustomImage()"
                title="Material You Custom Image"
                >
            </div>
          } @else {
			<div class="accent-switcher__file-text" (click)="triggerFileUpload($event)" (keydown.enter)="triggerFileUpload($event)" role="button" tabindex="0">
				<span class="material-symbols-rounded accent-switcher__file-icon">upload_file</span>
				<span class="accent-switcher__file-select-text">Use your image</span>
			</div>
          }
        </div>
	      } @else {
	        <responsive-image
	          [attr.id]="'accent-' + image"
	          class="accent-switcher__picture"
	          role="button" tabindex="0" [attr.aria-label]="'Image preview ' + image + ' theme'"
	          [imageName]="image + '-min'"
	          [imageAlt]="'Image preview ' + image + ' theme'"
          [imageHeight]="58" [imageWidth]="92"
          [imageBoundary]="512"
          [isLazyLoaded]="true"
          [attr.title]="titleMappings[image]"
        ></responsive-image>
      }
    </div>
  }
</article>
